import i18n from '@i18next/i18n';
import { EventCodeType, TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { PATH_ANIM_TYPES } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import { EMPH_ANIM_LIST, ENTR_ANIM_LIST, EXIT_ANIM_LIST, PATH_ANIM_LIST, PresetClassTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constants';
import { CUSTOM_PATH_ICON } from '@src/slide/domain/ui-model/element-modeles/property/animation/anim-icon';


export const ANIM_REPORT = {
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.SIDEBAR_ANIME,
};

export const REPORT_MAP = {
    addAnim: {
        action: TDWActionType.ADD_ANIME,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_ADD_ANIME,
    },
    deleteAnim: {
        action: TDWActionType.DELETE_ANIME,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_DELETE_ANIME,
    },
    playAnim: {
        action: TDWActionType.PLAY_ANIME,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_PLAY_ANIME,
    },
    playAll: {
        action: TDWActionType.PLAY_ALL,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_PLAY_ALL,
    },
    dragAnim: {
        action: TDWActionType.DRAG,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_DRAG,
    },
    animType: { // 动画类型
        action: TDWActionType.SWITCH_ANIME,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_SWITCH_ANIME,
    },
    delay: {  // 延迟
        action: TDWActionType.SET_DELAY,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_SET_DELAY,
    },
    subType: { // 方向
        action: TDWActionType.SET_DIRECTION,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_SET_DIRECTION,
    },
    duration: { // 持续时间
        action: TDWActionType.SET_DURATION,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_SET_DURATION,
    },
    nodeType: { // 开始
        action: TDWActionType.SET_START_WAY,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_SET_START_WAY,
    },
    clickSpid: { // 触发器
        action: TDWActionType.SET_TIRGGER,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_SET_TIRGGER,
    },
    setProperty: { // 设置属性
        action: TDWActionType.SET_PROPERTY,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_ANIME_SET_PROPERTY,
    },
};

export const ANIMATION_EDITOR_REF_ID = {
    SCROLL_CONTAINER: 'scrollContainer',
    EDITOR_BOTTOM: 'editorBottom',
    DROP_DOWN: 'dropDown',
};

export const EXTRA_PATH_ANIM_LIST = [
    ...PATH_ANIM_LIST,
    {
        id: PATH_ANIM_TYPES.CUSTOM,
        label: i18n.t('自定义路径'),
        icon: CUSTOM_PATH_ICON,
        presetClass: PresetClassTypes.PATH,
    },
].map(ani => ({ ...ani, disabled: true }));

export const ANIM_GALLERY = [
    {
        id: PresetClassTypes.ENTR,
        label: i18n.t('进入'),
        children: ENTR_ANIM_LIST,
    },
    {
        id: PresetClassTypes.EMPH,
        label: i18n.t('强调'),
        children: EMPH_ANIM_LIST,
    },
    {
        id: PresetClassTypes.EXIT,
        label: i18n.t('退出'),
        children: EXIT_ANIM_LIST,
    },
];

export const ANIM_RECENT_ID = 'recent';
export const ANIMATION_LIST = ANIM_GALLERY.reduce((pre, cur) => [...pre, ...cur.children], []);
export const ANIMATION_ICON_LIST = [...ANIMATION_LIST, ...EXTRA_PATH_ANIM_LIST];
